<script>
import Layout from "../../layouts/main.vue";
import Heading from "../../layouts/heading.vue";
import FormBuilder from "../../layouts/FormBuilder.vue";
import { schema } from "./data";
import api from "../../../api";
import Swal from "sweetalert2";
import { v4 as uuidv4 } from 'uuid';

export default {
  props: {
    category: {},
  },
  components: { 
    FormBuilder, 
    Layout,
     Heading
      },
  data() {
    return {
      page: schema,
      currentTopicActiveStatus: false,
      location_list: [],
      topics: [],
      topbar: {},
      selectedTab: '',
      selectedItem: {},
      default_permissions: {
        "Alert": {
          "CREATE": true,
          "READ": true,
          "UPDATE": true,
          "UPDATEMANY": true,
          "DELETE": true,
          "LIST": true,
          "COUNT": true,
          "EXECUTE": true,
          "AccessAuthFeature": true
        },
        "AlertSlug": {
          "CREATE": true,
          "READ": true,
          "UPDATE": true,
          "UPDATEMANY": true,
          "DELETE": true,
          "LIST": true,
          "COUNT": true,
          "EXECUTE": true,
          "AccessAuthFeature": true
        },
        "Category": {
          "CREATE": true,
          "READ": true,
          "UPDATE": true,
          "UPDATEMANY": true,
          "DELETE": true,
          "LIST": true,
          "COUNT": true,
          "EXECUTE": true,
          "AccessAuthFeature": true
        },
        "CategoryPage": {
          "CREATE": true,
          "READ": true,
          "UPDATE": true,
          "UPDATEMANY": true,
          "DELETE": true,
          "LIST": true,
          "COUNT": true,
          "EXECUTE": true,
          "AccessAuthFeature": true
        },
        "STP": {
          "CREATE": true,
          "READ": true,
          "UPDATE": true,
          "UPDATEMANY": true,
          "DELETE": true,
          "LIST": true,
          "COUNT": true,
          "EXECUTE": true,
          "AccessAuthFeature": true
        },
        "Cms": {
          "CREATE": true,
          "READ": true,
          "UPDATE": true,
          "UPDATEMANY": true,
          "DELETE": true,
          "LIST": true,
          "COUNT": true,
          "EXECUTE": true,
          "AccessAuthFeature": true
        },
        "CmsCategory": {
          "CREATE": true,
          "READ": true,
          "UPDATE": true,
          "UPDATEMANY": true,
          "DELETE": true,
          "LIST": true,
          "COUNT": true,
          "EXECUTE": true,
          "AccessAuthFeature": true
        },
        "CmsForm": {
          "CREATE": true,
          "READ": true,
          "UPDATE": true,
          "UPDATEMANY": true,
          "DELETE": true,
          "LIST": true,
          "COUNT": true,
          "EXECUTE": true,
          "AccessAuthFeature": true
        },
        "CmsPage": {
          "CREATE": true,
          "READ": true,
          "UPDATE": true,
          "UPDATEMANY": true,
          "DELETE": true,
          "LIST": true,
          "COUNT": true,
          "EXECUTE": true,
          "AccessAuthFeature": true
        },
        "CmsSlug": {
          "CREATE": true,
          "READ": true,
          "UPDATE": true,
          "UPDATEMANY": true,
          "DELETE": true,
          "LIST": true,
          "COUNT": true,
          "EXECUTE": true,
          "AccessAuthFeature": true
        },
        "Component": {
          "CREATE": true,
          "READ": true,
          "UPDATE": true,
          "UPDATEMANY": true,
          "DELETE": true,
          "LIST": true,
          "COUNT": true,
          "EXECUTE": true,
          "AccessAuthFeature": true
        },
        "FromEntry": {
          "CREATE": true,
          "READ": true,
          "UPDATE": true,
          "UPDATEMANY": true,
          "DELETE": true,
          "LIST": true,
          "COUNT": true,
          "EXECUTE": true,
          "AccessAuthFeature": true
        },
        "Form": {
          "CREATE": true,
          "READ": true,
          "UPDATE": true,
          "UPDATEMANY": true,
          "DELETE": true,
          "LIST": true,
          "COUNT": true,
          "EXECUTE": true,
          "AccessAuthFeature": true
        },
        "FormFormEntry": {
          "CREATE": true,
          "READ": true,
          "UPDATE": true,
          "UPDATEMANY": true,
          "DELETE": true,
          "LIST": true,
          "COUNT": true,
          "EXECUTE": true,
          "AccessAuthFeature": true
        },
        "Group": {
          "CREATE": true,
          "READ": true,
          "UPDATE": true,
          "UPDATEMANY": true,
          "DELETE": true,
          "LIST": true,
          "COUNT": true,
          "EXECUTE": true,
          "AccessAuthFeature": true
        },
        "GroupTeamMember": {
          "CREATE": true,
          "READ": true,
          "UPDATE": true,
          "UPDATEMANY": true,
          "DELETE": true,
          "LIST": true,
          "COUNT": true,
          "EXECUTE": true,
          "AccessAuthFeature": true
        },
        "LocationsPractice": {
          "CREATE": true,
          "READ": true,
          "UPDATE": true,
          "UPDATEMANY": true,
          "DELETE": true,
          "LIST": true,
          "COUNT": true,
          "EXECUTE": true,
          "AccessAuthFeature": true
        },
        "Mail": {
          "CREATE": true,
          "READ": true,
          "UPDATE": true,
          "UPDATEMANY": true,
          "DELETE": true,
          "LIST": true,
          "COUNT": true,
          "EXECUTE": true,
          "AccessAuthFeature": true
        },
        "Mail2": {
          "CREATE": true,
          "READ": true,
          "UPDATE": true,
          "UPDATEMANY": true,
          "DELETE": true,
          "LIST": true,
          "COUNT": true,
          "EXECUTE": true,
          "AccessAuthFeature": true
        },
        "Page": {
          "CREATE": true,
          "READ": true,
          "UPDATE": true,
          "UPDATEMANY": true,
          "DELETE": true,
          "LIST": true,
          "COUNT": true,
          "EXECUTE": true,
          "AccessAuthFeature": true
        },
        "PageSlug": {
          "CREATE": true,
          "READ": true,
          "UPDATE": true,
          "UPDATEMANY": true,
          "DELETE": true,
          "LIST": true,
          "COUNT": true,
          "EXECUTE": true,
          "AccessAuthFeature": true
        },
        "PracticeData": {
          "CREATE": true,
          "READ": true,
          "UPDATE": true,
          "UPDATEMANY": true,
          "DELETE": true,
          "LIST": true,
          "COUNT": true,
          "EXECUTE": true,
          "AccessAuthFeature": true
        },
        "PracticeDataAlert": {
          "CREATE": true,
          "READ": true,
          "UPDATE": true,
          "UPDATEMANY": true,
          "DELETE": true,
          "LIST": true,
          "COUNT": true,
          "EXECUTE": true,
          "AccessAuthFeature": true
        },
        "PracticeDataCms": {
          "CREATE": true,
          "READ": true,
          "UPDATE": true,
          "UPDATEMANY": true,
          "DELETE": true,
          "LIST": true,
          "COUNT": true,
          "EXECUTE": true,
          "AccessAuthFeature": true
        },
        "PracticeDataGroup": {
          "CREATE": true,
          "READ": true,
          "UPDATE": true,
          "UPDATEMANY": true,
          "DELETE": true,
          "LIST": true,
          "COUNT": true,
          "EXECUTE": true,
          "AccessAuthFeature": true
        },
        "Practice": {
          "CREATE": true,
          "READ": true,
          "UPDATE": true,
          "UPDATEMANY": true,
          "DELETE": true,
          "LIST": true,
          "COUNT": true,
          "EXECUTE": true,
          "AccessAuthFeature": true
        },
        "PracticeLocations": {
          "CREATE": true,
          "READ": true,
          "UPDATE": true,
          "UPDATEMANY": true,
          "DELETE": true,
          "LIST": true,
          "COUNT": true,
          "EXECUTE": true,
          "AccessAuthFeature": true
        },
        "PracticePracticeData": {
          "CREATE": true,
          "READ": true,
          "UPDATE": true,
          "UPDATEMANY": true,
          "DELETE": true,
          "LIST": true,
          "COUNT": true,
          "EXECUTE": true,
          "AccessAuthFeature": true
        },
        "Roles": {
          "CREATE": true,
          "READ": true,
          "UPDATE": true,
          "UPDATEMANY": true,
          "DELETE": true,
          "LIST": true,
          "COUNT": true,
          "EXECUTE": true,
          "AccessAuthFeature": true
        },
        "Slug": {
          "CREATE": true,
          "READ": true,
          "UPDATE": true,
          "UPDATEMANY": true,
          "DELETE": true,
          "LIST": true,
          "COUNT": true,
          "EXECUTE": true,
          "AccessAuthFeature": true
        },
        "TeamMembers": {
          "CREATE": true,
          "READ": true,
          "UPDATE": true,
          "UPDATEMANY": true,
          "DELETE": true,
          "LIST": true,
          "COUNT": true,
          "EXECUTE": true,
          "AccessAuthFeature": true
        },
        "User": {
          "CREATE": true,
          "READ": true,
          "UPDATE": true,
          "UPDATEMANY": true,
          "DELETE": true,
          "LIST": true,
          "COUNT": true,
          "EXECUTE": true,
          "AccessAuthFeature": true
        },
        "UsersPractice": {
          "CREATE": true,
          "READ": true,
          "UPDATE": true,
          "UPDATEMANY": true,
          "DELETE": true,
          "LIST": true,
          "COUNT": true,
          "EXECUTE": true,
          "AccessAuthFeature": true
        },
        "ObjectPermissions": {
          "CREATE": true,
          "READ": true,
          "UPDATE": true,
          "UPDATEMANY": true,
          "DELETE": true,
          "LIST": true,
          "COUNT": true,
          "EXECUTE": true,
          "AccessAuthFeature": true
        },
        "Training": {
          "CREATE": true,
          "READ": true,
          "UPDATE": true,
          "UPDATEMANY": true,
          "DELETE": true,
          "LIST": true,
          "COUNT": true,
          "EXECUTE": true,
          "AccessAuthFeature": true
        },
        "Home": {
          "CREATE": true,
          "READ": true,
          "UPDATE": true,
          "UPDATEMANY": true,
          "DELETE": true,
          "LIST": true,
          "COUNT": true,
          "EXECUTE": true,
          "AccessAuthFeature": true
        },
        "Analytics": {
          "CREATE": true,
          "READ": true,
          "UPDATE": true,
          "UPDATEMANY": true,
          "DELETE": true,
          "LIST": true,
          "COUNT": true,
          "EXECUTE": true,
          "AccessAuthFeature": true
        },
        "Network": {
          "CREATE": true,
          "READ": true,
          "UPDATE": true,
          "UPDATEMANY": true,
          "DELETE": true,
          "LIST": true,
          "COUNT": true,
          "EXECUTE": true,
          "AccessAuthFeature": true
        },
        "Settings": {
          "CREATE": true,
          "READ": true,
          "UPDATE": true,
          "UPDATEMANY": true,
          "DELETE": true,
          "LIST": true,
          "COUNT": true,
          "EXECUTE": true,
          "AccessAuthFeature": true
        },
        "Support": {
          "CREATE": true,
          "READ": true,
          "UPDATE": true,
          "UPDATEMANY": true,
          "DELETE": true,
          "LIST": true,
          "COUNT": true,
          "EXECUTE": true,
          "AccessAuthFeature": true
        }
      }
    };
  },
  methods: {
    create() {
        var val = this.page.tabs.filter(tab => tab.name == this.selectedTab)[0].formData;

        // console.log(val);
        var data = {
          uuid: uuidv4(),
          url: this.currentPractice.additionalProp1.url,
          active: true,
          title: val.name,
          picture: '',
          excerpt: 'Text here',
          description: 'Description here',
          deleted: false,          
          creationDate: new Date().toISOString(),
          lastModifiedDate: new Date().toISOString(),
          categoryId: this.category.id,
          cmsId: this.currentCms.id,
          pcnId: this.currentPracticeData.pcnId,
          permissions: this.default_permissions,
          additionalProp1: {
            dynamoId: this.currentPractice.additionalProp1.dynamo,            
          }
        };

        api.post('/api/roles/', data)
        .then((response) => {
          Swal.fire("Topic Added!", "Topic Added Successfully!", "success");
          this.page.tabs[0].side_panel.select_a_page.options.push(response.data);          
        }, (error) => {
          console.log(error);
        });
    },
    deleted() {
      var self = this;
      Swal.fire({
      title: `Are you sure you want to delete ${self.selectedItem.title}?`,
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#34c38f",
      cancelButtonColor: "#f46a6a",
      confirmButtonText: "Yes, delete it!"
      }).then(result => {
        if (result.value) {
          api.delete('/api/roles/'+this.selectedItem.id)
          .then(() => {
            Swal.fire("Topic Deleted!", "Topic Deleted Successfully!", "warning");
            this.page.tabs[0].side_panel.select_a_page.options
            .splice(
              this.page.tabs[0].side_panel.select_a_page.options.findIndex(function(i){
              return i.id === self.selectedItem.id;
            }), 1);
          }, (error) => {
            console.log(error);
          });
        }
      });
    },
    submit(val) {
      if(this.selectedTab == 'Permissions'){

        var new_permission = val.permissions;

        for (const key of Object.keys(val.permissions)) {
          new_permission[key]['READ'] = val[key];
        }

        var data = {
          title: val.title,
          description: '',
          active: this.currentTopicActiveStatus,
          permissions: new_permission,
          additionalProp1: {
            dynamoId: this.currentPractice.additionalProp1.dynamo,
          },
        };

        api.patch('/api/roles/'+val.id, data)
        .then(() => {
            this.page.tabs[0].side_panel.select_a_page.options.filter(l => l.id == val.id)[0].title = val.title;         
            this.page.tabs[0].side_panel.select_a_page.options.filter(l => l.id == val.id)[0].active = this.currentTopicActiveStatus;         
            this.page.tabs[0].side_panel.select_a_page.options.filter(l => l.id == val.id)[0].permissions = new_permission;    
            Swal.fire("Role Updated!", "role Updated Successfully!", "success");
        }, (error) => {
          console.log(error);
        });
      }
    },
    activateToggle() {
      this.currentTopicActiveStatus = !this.currentTopicActiveStatus;
      var data = {
        active: this.currentTopicActiveStatus
      };
      api.patch('/api/roles/'+this.selectedItem.id, data)
      .then(() => {       
          this.page.tabs[0].side_panel.select_a_page.options.filter(l => l.id == this.selectedItem.id)[0].active = this.currentTopicActiveStatus;  
          Swal.fire("Role Status Updated!", "Role Status Updated Successfully!", "success");
      }, (error) => {
        console.log(error);
      });
    },
    selectedItemFn(val) {
      this.selectedItem = val;
      this.currentTopicActiveStatus = val.active;
    },
    selectedTabFn(val) {
      this.selectedTab = val;
      this.topbar = this.page.tabs.filter(tab => tab.name == val)[0];
    },
    getPages() {
      api.get('/api/roles/')
      .then(response => {
        this.topics = response.data;
        this.page.tabs[0].side_panel.select_a_page.options = response.data;  
        this.topbar = this.page.tabs[0];
      })
      .catch(e => {
        console.log(e)
      })  
    },
  },
  computed: {
  },
  watch: {
  },
  mounted() {
    this.getPages();
    // this.topbar = this.page.tabs[0];
  }
};
</script>

<template>
  <Layout>
    <Heading :page="topbar" 
      :activeStatus="currentTopicActiveStatus" 
      @activateToggle="activateToggle"
      @created="create" 
      @deleted="deleted" 
      @form-submitted="submit"
    >
    </Heading>
    <FormBuilder :schema="page" :category="category" @selected-tab="selectedTabFn" @submit="submit" @selected-item="selectedItemFn">
    </FormBuilder>
  </Layout>
</template>